import script from "./GameUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./GameUsers.vue?vue&type=script&setup=true&lang=js"

import "@/styles/_gameUsers.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__